/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   10/11/2022
 */

import React from "react";
import {Stack} from "@mui/material";
import LinkedCalendarSelector from "../../controls/LinkedCalendarSelector";
import {UseFormReturnType} from "@mantine/form";
import {SummaryNotificationConfig} from "../../interfaces/Global";
import EmployeeNameFormatSelector from "./EmployeeNameFormatSelector";
import CapacityFormatSelector from "./CapacityFormatSelector";
import SlackTextInput from "../../controls/SlackTextInput";

export interface ConfigSettingsProps {
	form: UseFormReturnType<SummaryNotificationConfig>
}

export default function ConfigSettings({form}: ConfigSettingsProps) {

	return (
		<Stack spacing={2} mb={2}>
			<LinkedCalendarSelector
				calendarId={form.values.calendarId}
				setCalendarId={calendarId => form.setFieldValue('calendarId', calendarId ?? 0)}
				hint={form.values.employeesSource === "calendar" ?
					"Linked calendar is required to source the employees from it." :
					"If provided, a link to this calendar will be included in a Slack message for quick access."}
			/>
			<EmployeeNameFormatSelector
				value={form.values.employeeNameFormat}
				setValue={(format) => form.setFieldValue('employeeNameFormat', format)}
			/>
			<CapacityFormatSelector
				value={form.values.capacityFormat}
				setValue={(format) => form.setFieldValue('capacityFormat', format as any)}
			/>
			<SlackTextInput
				label={"Optional Introductory Text Message"}
				placeholder={"Optional"}
				value={form.values.introText || ""}
				onChange={value => form.setFieldValue('introText', value)}
			/>
		</Stack>
	);

}